module.exports = __webpack_public_path__ + "img/error.c2e7bff3.jpg";